export default {
    title: '产品与技术',
    btnContractUs: 'Demo联系我们',
    btnGetProduct: '获取产品详情',
    regulatoryManagement: {
        title1: '机构风险评估系统',
        content1: '风险评估系统支持金融机构开展各类风险评估工作，包括反洗钱、反恐融资和制裁的机构风险自评估。金融机构可以借助该系统完成自定义评估方法论、全流程审批、问卷填报与监控、统计分析、报表定制、差异化资源与数据权限配置等。它能有效帮助金融机构鸟瞰风险全景、轻松生成报告、满足监管论证要求、并追踪合规改进事项。',
        title2: '风险指数工具',
        content2: '提供风险动态数据，支持金融机构开展日常合规评估工作。他整合权威监管和统计数据，并有效结合专家判断和执法经验，客观、科学地评估国家和地区(可下钻至中国各省和市)、产品与服务、行业和职业所带来的制裁和洗钱风险，为金融机构实施以风险为本的合规管理奠定良好基础。',
        title3: '名单监控系统',
        content3: '多语言的客户和交易筛查系统，支持名单库管理、算法管理、实时筛查、预警人工甄别等功能，利用人工智能和机器学习等前沿科技，实现更精准的筛查和识别，减少误中，提高效率。',
        title4: '合规检查系统',
        content4: '基于但数据分析技术和先进的规则算法，协助金融机构执行自动化的数据质量和政策流程检查。依据监管机构对数据质量和业务规范的要求，参考监管检查时关注的重点，应用了丰富的模型和规则，用以挖掘数据中存在的质量问题与业务逻辑问题，亦可对监管要求和政策流程进行点对点的检查，以快速识别控制薄弱环节。',
        title5: '客户尽职调查系统',
        content5: '支持客户信息收集，一般尽职调查，强化尽职调查和持续尽职调查等关键流程，符合最新监管要求。另外，系统内嵌客户评级模块，支持多层级的评级结构；客户信息收集模块内设数据校验规则，有助于数据质量的控制，有效提升客户尽职调查的质量。',
        title6: '交易监控系统',
        content6: '可实现指标和规则在页面无代码的灵活配置，支持业务人员有效分配规则和实施监控。系统内设数百条规则，全面覆盖银行，证券，保险和支付等各类金融机构需求。另外，系统结合机器学习等算法、图数据等工具，从海量交易中捕捉藏匿的资金往来关系进行直观展现，有力辅助调查员进行有效监控。',
    },
    riskManagement: {
        title1: '市场风险管理系统',
        content1: '基于自主研发的C++高效计量引擎核心，支持高性能系统/手动跑批任务管理。可有效支持金融机构开展市场风险现行内模法计量，结合市场风险数据管理平台方案，提供估值、损益计算、VaR计量、返回校验、特定风险、压力测试及资本计量等功能。协助银行、保险和资产管理公司完善风险管控流程，包括交易台监控、限额管控、报告优化。',
        title2: '市场风险新标准法FRTB计量系统',
        content2: '基于自主研发的C++高效计量引擎核心、支持银行开展一般利率、信用利差、汇率、股票、商品风险类别Delta、Vega、Curvature敏感性指标的计量与汇总、违约资本计量等功能。结合标准监管数据模型与数据接入方案，提供数据治理、交易台管理、风险计量、限额设置、资本管理、绩效考核等功能。',
        title3: '风险数据加总与风险报告合规评估系统',
        content3: '支持金融机构开展巴塞尔239原则、银保监会与香港金管局评估点监管合规评估问卷。系统预设自定义评估方法论支持近200个评估指标，以及各风险管理、报表制定等。依托于锐查平台，基于EAST接口，可支持金融机构部署系统预设数据质量控制规则、总账核对规则。',
        title4: '流动性管理和监管报告系统',
        content4: '支持金融机构开展全流程现金流计算及管理报告的自动化。依托于模型实验室，支持金融机构基于实际数据构建资产负债表结构的客户行为模型，包括存款流失、存款提前支取、贷款提前还款、贷款续期率等模型，并应用于管理预测。',
        title5: 'BIII RWA资本计量系统',
        content5: '引入大数据和Spark处理技术，提高批处理的速度，解决存储大量数据的问题。支持金融机构基于同一套数据接口、通过灵活的规则配置，部署多套资本充足率计量规则。它的资本管理模块可有效协助金融机构开展年度规划、配置与管理应用。',
        title6: '操作风险损失事件管理系统',
        content6: '支持金融机构开展操作风险事件及损失数据的收集管理，包括规范损失事件录入流程、开展损失事件分类、进行资本新规计量等功能。',
        title7: '整合资本与流动性压力测试引擎',
        content7: '支持金融机构开展整合资本压力测试与流动性压力测试。压力测试场景可覆盖金融机构各类需求，包括ICAAP压力测试、季度压力测试、专项压力测试、以及恢复与处置计划压力测试。',
    },
    newTechnologiesAndNewTrends: {
        title1: '模型管理平台',
        content1: '整合的模型管理平台汇集了传统统计方法、人工智能和机器学习算法。算法包括专家规则、逻辑回归、随机森林、图计算、随机场算法、卷积神经网络算法等，被应用于锐合现有的客户身份识别、客户风险评级、交易监控、制裁筛选，法规解读等产品中。平台实现对模型生命周期的管理，从指标数据准备、指标标准化、模型设计、模型开发、模型验证、模型表现评估、模型监控，到模型版本管理、模型比较分析和模型在线部署。',
        title2: '机器人流程自动化（RPA）',
        content2: 'RPA深度融合先进的自研人工智能技术，实现金融机构在客户准入，信息识别，信息核实等业务流程自动化和智能辅助，提高了业务运营效率，已成功应用于信息采集和录入、自动对比、报表处理、合同分析等众多业务场景，有效降低文本处理流程中的认为错误风险，助力数字化升级。',
        title3: '气候变化',
        content3: '锐合的气候风险咨询服务，是围绕“双碳”目标为企业提供规划与培训、气候风险财务披露与上市企业ESG披露、碳税与绿色金融、碳数字化与系统建设、行业标准建设、碳创投支持等服务。依托于锐合的风险管理基因，锐合为金融机构提供气候风险治理、气候风险偏好、压力测试与规划工作框架、绿色信用风险模型提升、碳税及衍生品估值、气候风险财务披露（TCED）。',
    },
    libraryAndSetting: {
        title1: '锐库——————法规库',
        content1: '锐合的法规库“锐库”结合自然语言处理等新兴技术，整合全球主要司法辖区的合规和风险管理的监管要求和预期。锐库及时地追踪监管要求与预期的变化，并对金融机构内部政策和流程进行匹配和自动化检查，识别政策和流程文件中可能存在的关键差距，以协助金融机构不断完善合规政策体系。',
        title2: '锐案——————案件和风险事件库',
        content2: '锐合的案例库覆盖近10年来国内外监管机构对金融机构行政处罚的案例，以及中国地区金融刑事与民事案件。案例库为支持监控系统和风险评估系统提供有效地支持。',
    },
    getProductIntroduce: '请您反馈以下信息，我们的产品专员将尽快联系您：',
    inputNeed: '请选择您的需求类型',
    type1: '我想获取产品介绍',
    type2: '我想预约产品demo',
    type3: '我想了解更多信息',
    inputRemark: '请描述您想了解的具体内容',
    inputProductType: '请输入您想要咨询的产品或产品类型',
    inputOrganizationName: '请输入您所在的机构名称',
}